var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 14.9334,
  height: 14.9333,
  viewBox: "0 0 14.9334 14.9333",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group 23"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M5.91253 0.466668C3.62091 0.491619 2.34195 0.637227 1.49217 1.48702C0.466667 2.51251 0.466667 4.16304 0.466667 7.46402C0.466667 10.7651 0.466667 12.4157 1.49217 13.4412C2.51767 14.4667 4.1682 14.4667 7.46925 14.4667C10.7703 14.4667 12.4208 14.4667 13.4463 13.4412C14.2963 12.5912 14.4417 11.3118 14.4667 9.01935",
  stroke: "#A69782",
  strokeWidth: 0.933333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M9.0223 0.466668H12.1334C13.2333 0.466668 13.7833 0.466668 14.1251 0.808377C14.4667 1.15009 14.4667 1.70006 14.4667 2.8V5.91111M13.689 1.24445L6.68897 8.24445",
  stroke: "#A69782",
  strokeWidth: 0.933333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-share.4115004686a9ee6ef32335a8bc122b04.svg";